import { useEffect, useState } from 'react';

import { listLeadSource } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useLeadSource(excludeFromLoading = false) {
  const [List, setList] = useState([]);
  const [isLeadSourceLoading, setIsLeadSourceLoading] = useState(false);

  const loadLeadSources = () => {
    setIsLeadSourceLoading(true);
    totalCountEvent('lead_source')
      .then((response) => {
        listLeadSource(response.data, '', 'forward', excludeFromLoading)
          .then((res) => {
            if (res.data?.lead_source?.length) {
              setList(res.data.lead_source);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => setIsLeadSourceLoading(false));
      })
      .catch((err) => {
        setIsLeadSourceLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    loadLeadSources();
  }, []);

  return { leadSourceList: List, isLeadSourceLoading, loadLeadSources };
}
